import { useContext, useMemo } from 'react';
import { useReadContract } from 'wagmi';
import LVMONRedeemerABI from '@ui/services/contract/abis/LVMONRedeemer';
import { useDataChainId } from '@ui/hooks/datachain/useDataChainStore';
import { getContractAddress } from '@ui/services/contract/constants/address';
import { ExchangeContext } from '@ui/features/Exchange/Context';
import { parseUnits } from 'viem';

export const useDailyRedeemLimit = () => {
  const chainId = useDataChainId();
  const redeemerAddress = getContractAddress('LVMONRedeemer', chainId);
  const { inputAmount, inputToken } = useContext(ExchangeContext);

  const { data: status } = useReadContract({
    address: redeemerAddress,
    abi: LVMONRedeemerABI,
    functionName: 'getDailyRedeemStatus',
    query: {
      enabled: !!redeemerAddress,
      refetchInterval: 10000, // Refresh every 10s
    },
  });

  const [totalLimit, remaining, nextResetTime] = status || [0n, 0n, 0n];

  const inputAmountBN = useMemo(() => {
    if (!inputAmount || !inputToken) return 0n;
    try {
      return parseUnits(inputAmount, inputToken.decimals);
    } catch {
      return 0n;
    }
  }, [inputAmount, inputToken]);

  const isExceeded = inputAmountBN > remaining;

  return {
    totalLimit,
    remaining,
    nextResetTime,
    isExceeded,
    status
  };
};
